module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/picture_1-40f9df203dffa5f995fc9f63e7f99b99.webp";